module.exports = __webpack_public_path__ + "static/equipment1-8ff446f02975f9475bc8b7eae77fff38.jpg";